// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"29":"d71fd507","229":"7109afe9","427":"200e2ce7","579":"800abff7","723":"aa660f5e","957":"e8b8f7f1"}[chunkId] + ".chunk.css";
};